/** Sentence-case a SNAKE_CASE enum for display: `READY_FOR_PICKING` →
 *  "Ready for picking". Short tokens (≤2 chars) read as acronyms/system codes
 *  (`AS`, `PL`) and stay uppercase. */
export function humanizeEnumLabel(value: string): string {
  const words = value.split("_").map((w) => (w.length <= 2 ? w.toUpperCase() : w.toLowerCase()))
  const first = words[0]
  if (first && first !== first.toUpperCase()) {
    words[0] = first.charAt(0).toUpperCase() + first.slice(1)
  }
  return words.join(" ")
}
